module.exports = __webpack_public_path__ + "media/svg/reviews-selected-761dab33.svg";